// How a citation names a document: an upload's 22-character id, or the synthetic id a
// document synced from BMA is stored under. Must agree with upload_ids.UPLOAD_ID.
export const UPLOAD_ID = String.raw`(?:[A-Za-z0-9_-]{22}|bma-(?:survey|cost-sheet):[0-9a-f-]{36})`;
